// Module
var code = "<react-component name=\"CheckedInAttendance\"></react-component>\n";
// Exports
module.exports = code;